import React from 'react'
import { IndexRedirect, Route, Redirect } from 'react-router'

import ComposeReplyModalWrapper from 'components/settings/reply/ComposeReplyModalWrapper'
import ManageInbox from 'components/settings/inboxes/ManageInbox'
import UserProfile from 'components/settings/UserProfile'
import AssistantConfigOrg from 'components/settings/AssistantConfigOrg'
import ManageSavedReplies from 'components/settings/reply/ManageSavedReplies'
import RulesHome from 'components/settings/Rules/containers/RulesHome'
import RulesEditor from 'components/settings/Rules/containers/RulesEditor'
import IntegrationList from 'components/Integration/List'
import SalesforceMapping from 'components/Integration/pages/SalesforceMapping'
import SalesforceConfig from 'components/Integration/pages/SalesforceConfig'
import SalesforceAccountSyncErrors from 'components/Integration/pages/SalesforceAccountSyncErrors'
import HubspotConfig from 'components/Integration/pages/HubspotConfig'
import MarketoConfig from 'components/Integration/pages/MarketoConfig'
import EloquaConfig from 'components/Integration/pages/EloquaConfig'
import PardotConfig from 'components/Integration/pages/PardotConfig'
import SalesforceUserMapping from 'components/Integration/pages/SalesforceUserMapping'
import SalesforceRoutingSettings from 'components/Integration/pages/SalesforceRoutingSettings'
import SalesforceMetricsMapping from 'components/Integration/pages/SalesforceMetricsMapping'
import MarketoAttributeMapping from 'components/Integration/pages/MarketoAttributeMapping'
import HubspotUserMapping from 'components/Integration/pages/HubspotUserMapping'
import HubspotAttributeMapping from 'components/Integration/pages/HubspotAttributeMapping'
import EloquaAttributeMapping from 'components/Integration/pages/EloquaAttributeMapping'
import EloquaAttributeMappingCdo from 'components/Integration/pages/EloquaAttributeMappingCdo'
import PardotAttributeMapping from 'components/Integration/pages/PardotAttributeMapping'
import IntegrationEventLog from 'components/Integration/pages/IntegrationEventLog'
import PageLayout from 'components/Integration/PageLayout'
import Settings from 'components/settings/Settings'
import ConversationsSettings from 'components/settings/conversations'
import AdvancedConversationSettings from 'components/settings/advancedConversationSettings'
import ChatWidgetSettings from 'components/settings/ChatWidget'
import HoursAndTargeting from 'components/settings/ChatWidget/components/HoursAndTargeting'
import ChatWidgetDesignContainer from 'components/settings/ChatWidget/components/Design'
import ChatWidgetWelcomeMessage from 'components/settings/ChatWidget/components/WelcomeMessage'
import AdvancedChatWidgetSettings from 'components/settings/ChatWidget/components/Advanced'
import GlobalCalendarSettings from 'components/settings/GlobalCalendarSettings'
import ACCESS from 'utils/Access'
import { IntegrationIds } from 'components/Integration/ListConstants.js'
import AuthHOC from 'app/utils/gateChecker'

import { Routes as CalendarRoutes } from 'components/settings/meetings/routes'

const createRoutes = store => (
  <Route path="settings" component={Settings}>
    <IndexRedirect to="team" />
    <Route path="consent/edit/:language" component={(route) => window.location.replace(`/settings2/consent/edit/${route.params.language}`)} />
    <Route path="consent/new" component={() => window.location.replace('/settings2/consent/new')} />
    <Route path="consent" component={() => window.location.replace('/settings2/consent')} />
    <Route path="dkim" component={() => window.location.replace('/settings2/dkim')} />
    <Route path="email" component={() => window.location.replace('/settings2/email')} />
    <Route path="notifications" component={() => window.location.replace('/settings2/notifications')} />
    <Route path="notifications/advanced" component={() => window.location.replace('/settings2/notifications/advanced')} />
    <Route path="account" component={() => window.location.replace('/settings2/account')} />
    <Route path="assistant" component={() => window.location.replace('/settings2/assistant')} />
    <Route path="profile" component={() => window.location.replace('/settings2/profile')} />
    <Route path="assistant/org" component={AssistantConfigOrg} />
    <Route path="teams" component={() => window.location.replace('/settings2/teams')} />
    <Route path="teams/:teamId" component={(route) => window.location.replace(`/settings2/teams/${route.params.teamId}`)} />
    <Route path="company" component={() => window.location.replace('/settings2/company')} />
    <Route path="team" component={() => window.location.replace('/settings2/team')} />
    <Route path="billing" component={() => window.location.replace('/settings2/billing')} />
    <Redirect from="routing" to="bot" />
    <Redirect from="driftbot" to="bot" />
    <Route path="bot" component={() => window.location.replace('/settings2/bot')} />
    <Route path="rules" component={RulesHome} />
    <Route path="rules/:ruleId" component={RulesEditor} />
    <Route path="manage-inboxes/:inboxId" component={ManageInbox} />
    <Route path="team/user-logs" component={() => window.location.replace('/settings2/user-logs')}  />
    <Route path=":integrationId/event-log" component={AuthHOC.applyGateCheckerThroughProps(IntegrationEventLog)} />
    {CalendarRoutes(store)}
    <Route path="conversations/advanced" component={() => window.location.replace('/settings2/conversations/advanced')} />
    <Route path="conversations" component={() => window.location.replace('/settings2/conversations')} />
    <Route path="widget" component={ChatWidgetSettings}>
      <Route path="hours-and-targeting" component={HoursAndTargeting} />
      <Route path="design" component={ChatWidgetDesignContainer} />
      <Route path="default-greeting" component={ChatWidgetWelcomeMessage} />
      <Redirect from="welcome-message" to="default-greeting" />
      <Route path="advanced" component={AdvancedChatWidgetSettings} />
    </Route>
    <Route path="replies" component={ManageSavedReplies}>
      <Route path="compose/:replyId" component={ComposeReplyModalWrapper} />
    </Route>
    <Route path="integrations" component={IntegrationList} />
    <Route path="authentication" component={() => window.location.replace('/settings2/security')} />
    <Route path="security" component={() => window.location.replace('/settings2/security')} />
    <Route path="global/calendars" component={GlobalCalendarSettings} />
    <Route path="setup/:integrationId" component={AuthHOC.applyGateCheckerThroughProps(PageLayout)} />
    <Route path="salesforce/routing" component={AuthHOC.applyGateChecker(SalesforceRoutingSettings, IntegrationIds.SALESFORCE)} />
    <Route path="salesforce/mapping/attributes" component={AuthHOC.applyGateChecker(SalesforceMapping, IntegrationIds.SALESFORCE)} />
    <Route path="salesforce/mapping/attributes/metrics" component={AuthHOC.applyGateChecker(SalesforceMetricsMapping, IntegrationIds.SALESFORCE)} />
    <Route path="salesforce/mapping/users" component={AuthHOC.applyGateChecker(SalesforceUserMapping, IntegrationIds.SALESFORCE)} />
    <Route path="salesforce/config" component={AuthHOC.applyGateChecker(SalesforceConfig, IntegrationIds.SALESFORCE)} />
    <Route path="salesforce/config/account-sync-errors" component={AuthHOC.applyGateChecker(SalesforceAccountSyncErrors, IntegrationIds.SALESFORCE)} />
    <Route path="hubspot/config" component={AuthHOC.applyGateChecker(HubspotConfig, IntegrationIds.HUBSPOT)} />
    <Route path="hubspot/mapping/attributes" component={AuthHOC.applyGateChecker(HubspotAttributeMapping, IntegrationIds.HUBSPOT)} />
    <Route path="hubspot/mapping/users" component={AuthHOC.applyGateChecker(HubspotUserMapping, IntegrationIds.HUBSPOT)} />
    <Route path="marketo/config" component={AuthHOC.applyGateChecker(MarketoConfig, IntegrationIds.MARKETO)} />
    <Route path="marketo/mapping/attributes" component={AuthHOC.applyGateChecker(MarketoAttributeMapping, IntegrationIds.MARKETO)} />
    <Route path="eloqua/config" component={EloquaConfig} />
    <Route path="eloqua/mapping/attributes" component={EloquaAttributeMapping} />
    <Route path="eloqua/mapping/attributes/cdo" component={EloquaAttributeMappingCdo} />
    <Route path="pardot/config" component={PardotConfig}
      onEnter={(nextState, replace) => {
        if (!(ACCESS.hasGates('HAS_PARDOT'))) {
          replace('/integrations')
        }
      }} />
    <Route path="pardot/mapping/attributes" component={PardotAttributeMapping}
      onEnter={(nextState, replace) => {
        if (!(ACCESS.hasGates('HAS_PARDOT'))) {
          replace('/integrations')
        }
      }} />
    <Redirect from="apps" to="integrations" />
    <Redirect from="tags" to="conversations" />
    <Redirect from="manage-inboxes" to="conversations" />
    <Redirect from="livechat" to="widget" />
  </Route>
)

export default createRoutes



// WEBPACK FOOTER //
// ./src/scripts/app/routes/SettingsRoutes.js